import { request } from '@src/utility/request'
import { getGlobalOrg } from '@utils'

export const getBookingReport = async (params) => await request({
  method: 'get',
  url: '/booking/report',
  params
})

export const getPrices = async (params) => await request({
  method: 'get',
  url: '/apidata/price',
  params
})

export const putPrice = async (data) => {
  if (data && data.id) {
    const response = await request({
      method: 'put',
      url: `/apidata/price/${data.id}/${getGlobalOrg()}`,
      data
    })

    if (response && response.status === 200) {
      return response.data
    } else {
      throw new Error('Oops, backend server error')
    }
  }
}

export const postPrice = async (data) => {
  if (data) {
    const response = await request({
      method: 'post',
      url: `/apidata/addPrice/${getGlobalOrg()}`,
      data
    })

    if (response && response.status === 200) {
      return response.data
    } else {
      throw new Error('Oops, backend server error')
    }
  }
}

export const deletePrice = async (data) => {
  if (data && data.id) {
    const response = await request({
      method: 'delete',
      url: `/apidata/price/${data.id}/${getGlobalOrg()}`,
      data
    })

    if (response && response.status === 200) {
      return response.data
    } else {
      throw new Error('Oops, backend server error')
    }
  }
}

export const getHours = async (params) => await request({
  method: 'get',
  url: '/apidata/hours',
  params
})

export const getHoursCombined = async (params) => await request({
  method: 'get',
  url: '/apidata/hoursCombined',
  params
})

export const putHour = async (data) => {
  if (data && data.id) {
    const response = await request({
      method: 'put',
      url: `/apidata/hours/${data.id}/${getGlobalOrg()}`,
      data
    })

    if (response && response.status === 200) {
      return response.data
    } else {
      throw new Error('Oops, backend server error')
    }
  }
}

export const postHour = async (data) => {
  if (data) {
    const response = await request({
      method: 'post',
      url: `/apidata/hours/${getGlobalOrg()}`,
      data
    })

    if (response && response.status === 200) {
      return response.data
    } else {
      throw new Error('Oops, backend server error')
    }
  }
}

export const deleteHour = async (data) => {
  if (data && data.id) {
    const response = await request({
      method: 'delete',
      url: `/apidata/hours/${data.id}/${data.orgId}`,
      data
    })

    if (response && response.status === 200) {
      return response.data
    } else {
      throw new Error('Oops, backend server error')
    }
  }
}

export const validateDeleteHours = async (data) => {
  if (data && data.id) {
    const response = await request({
      method: 'post',
      url: `/apidata/validatehours/${data.id}/${data.orgId}`,
      data
    })

    if (response && response.status === 200) {
      return response.data
    } else {
      throw new Error('Oops, backend server error')
    }
  }
}

export const getFields = async (orgId) => await request({
  method: 'get',
  url: `/apidata/fields/${orgId}`
})

export const getActiveFields = async (orgId) => await request({
  method: 'get',
  url: `/apidata/activeFields/${orgId}`
})

export const putField = async (data) => {
  if (data) {
    const response = await request({
      method: 'put',
      url: '/apidata/field',
      data
    })

    if (response && response.status === 200) {
      return response.data
    } else {
      throw new Error('Oops, backend server error')
    }
  }
}

export const postField = async (data) => {
  if (data) {
    const response = await request({
      method: 'post',
      url: `/apidata/addField/${getGlobalOrg()}`,
      data
    })

    if (response && response.status === 200) {
      return response.data
    } else {
      throw new Error('Oops, backend server error')
    }
  }
}

export const archiveField = async (data) => {
  if (data && data.id) {
    const response = await request({
      method: 'delete',
      url: `/apidata/field/${data.id}/${getGlobalOrg()}`,
      data
    })

    if (response && response.status === 200) {
      return response.data
    } else {
      throw new Error('Oops, backend server error')
    }
  }
}

export const getFacilityDetails = async (orgId) => await request({
  method: 'get',
  url: `/apidata/facilityDetails/${orgId}`
})

export const editFacility = async (data) => {
  if (data && data.id) {
    const response = await request({
      method: 'put',
      url: `/apidata/editFacility/${data.id}/${getGlobalOrg()}`,
      data
    })

    if (response && response.status === 200) {
      return response.data
    } else {
      throw new Error('Oops, backend server error')
    }
  }
}

export const addFacility = async (data) => {
  if (data) {
    const response = await request({
      method: 'post',
      url: `/apidata/addFacility/${getGlobalOrg()}`,
      data
    })

    if (response && response.status === 200) {
      return response.data
    } else {
      throw new Error('Oops, backend server error')
    }
  }
}

export const archiveFacility = async (data) => {
  if (data && data.id) {
    const response = await request({
      method: 'delete',
      url: `/apidata/archiveFacility/${data.id}/${getGlobalOrg()}`,
      data
    })

    if (response && response.status === 200) {
      return response.data
    } else {
      throw new Error('Oops, backend server error')
    }
  }
}

export const getOrgs = async () => await request({
  method: 'get',
  url: '/org/orgs'
})

export const getOrgsDetails = async () => await request({
  method: 'get',
  url: '/org/orgsDetails'
})

export const editOrg = async (data) => {
  if (data && data.get('id')) {
    const response = await request({
      method: 'put',
      url: `/org/editOrg/${data.get('id')}`,
      data
    })

    if (response && response.status === 200) {
      return response.data
    } else {
      throw new Error('Oops, backend server error')
    }
  }
}

export const addOrg = async (data) => {
  if (data) {
    const response = await request({
      method: 'post',
      url: '/org/addOrg',
      data
    })

    if (response && response.status === 200) {
      return response.data
    } else {
      throw new Error('Oops, backend server error')
    }
  }
}

export const getOrgMembers = async (id) => await request({
  method: 'get',
  url: `/member/orgMem/${id}`
})

export const getOrgNonMembers = async (id) => await request({
  method: 'get',
  url: `/member/nonMembers/${id}`
})

export const getOrgMember = async (orgId, id) => await request({
  method: 'get',
  url: `/member/orgMember/${orgId}/${id}`
})

export const addNonMember = async (data) => await request({
  method: 'post',
  url: `/member/addNonMem/${data.orgId}`,
  data
})

export const putOrgMember = async (data) => {
  if (data && data.id) {
    const response = await request({
      method: 'put',
      url: `/member/orgMem/${data.id}/${data.orgId}`,
      data
    })

    if (response && response.status === 200) {
      return response.data
    } else {
      throw new Error('Oops, backend server error')
    }
  }
}

export const postOrgMember = async (data) => {
  if (data) {
    const response = await request({
      method: 'post',
      url: `/member/addOrgMem/${data.orgId}/${data.facilityId}`,
      data
    })

    if (response && response.status === 200) {
      return response.data
    } else {
      throw new Error('Oops, backend server error')
    }
  }
}

export const deleteOrgMember = async (data) => {
  if (data && data.id) {
    const response = await request({
      method: 'delete',
      url: `/member/orgMem/${data.id}/${data.orgId}`,
      data
    })

    if (response && response.status === 200) {
      return response.data
    } else {
      throw new Error('Oops, backend server error')
    }
  }
}

export const verifyOrgMember = async (data) => {
  if (data && data.id) {
    const response = await request({
      method: 'put',
      url: `/member/orgMem/verify/${data.id}/${data.orgId}`,
      data
    })

    if (response && response.status === 200) {
      return response.data
    } else {
      throw new Error('Oops, backend server error')
    }
  }
}

export const postOrgMemberFile = async (data) => {
  if (data) {
    const response = await request({
      method: 'post',
      url: '/member/uploadOrgMemFile',
      data
    })
    if (response && response.status === 200) {
      return response.data
    } else {
      throw new Error('Oops, backend server error')
    }
  }
}

export const getOrgUsers = async () => await request({
  method: 'get',
  url: '/org/orgUsers'
})

export const findOrgUser = async (params) => await request({
  method: 'get',
  url: '/org/orgUser',
  params
})

export const editOrgUser = async (data) => {
  if (data && data.id) {
    const response = await request({
      method: 'put',
      url: `/org/editOrgUser/${data.id}/${data.orgId}`,
      data
    })

    if (response && response.status === 200) {
      return response.data
    } else {
      throw new Error('Oops, backend server error')
    }
  }
}

export const addOrgUser = async (data) => {
  if (data) {
    const response = await request({
      method: 'post',
      url: `/org/addOrgUser/${data.orgId}`,
      data
    })

    if (response && response.status === 200) {
      return response.data
    } else {
      throw new Error('Oops, backend server error')
    }
  }
}

export const deleteOrgUser = async (data) => {
  if (data && data.id) {
    const response = await request({
      method: 'delete',
      url: `/org/delOrgUser/${data.id}/${data.orgId}`,
      data
    })

    if (response && response.status === 200) {
      return response.data
    } else {
      throw new Error('Oops, backend server error')
    }
  }
}

export const getSports = async () => await request({
  method: 'get',
  url: '/apidata/sport'
})

export const editSport = async (data) => await request({
  method: 'put',
  url: '/apidata/editSport',
  data
})

export const addSport = async (data) => await request({
  method: 'post',
  url: '/apidata/addSport',
  data
})

export const delSport = async (data) => await request({
  method: 'delete',
  url: `/apidata/delSport/${data.id}`
})

export const getReports = async () => await request({
  method: 'get',
  url: '/report'
})

export const getSuperAdminDashboard = async (params) => await request({
  method: 'get',
  url: '/mgmt/dashboard',
  params
})

export const refreshSuperAdminDashboard = async (params) => await request({
  method: 'post',
  url: '/mgmt/dashboard/refresh',
  params
})

export const getReportData = async (params) => await request({
  method: 'get',
  url: `/report/data/${params.orgId}`,
  params
})

export const getOrgMarkers = async (orgId) => await request({
  method: 'get',
  url: `/org/orgMarkers/${orgId}`
})

export const getFieldImages = async (params) => await request({
  method: 'get',
  url: `/apidata/images/field/${params.field}/1`
})

export const getOrgMembersForProgram = async (params) => await request({
  method: 'get',
  url: `/coaching/orgMemProg/${params.progId}/${params.orgId}`
})

export const bulkEnrolToBatch = async (data) => await request({
  method: 'post',
  url: `/coaching/bulkEnrolToBatch/${data.orgId}`,
  data
})

export const getPendingEnrols = async (data) => await request({
  method: 'get',
  url: `/coaching/enrolment/pending/${data.phone}`
})

export const addEnrolToBatch = async (data) => await request({
  method: 'post',
  url: `coaching/addEnrolToBatch/${data.orgId}`,
  data
})

export const editEnrolDate = async (params) => await request({
  method: 'put',
  url: `/coaching/editEnrolDate/${params.id}/${params.orgId}`,
  params
})

export const editEnrolBatch = async (params) => await request({
  method: 'put',
  url: `/coaching/editEnrolBatch/${params.id}/${params.orgId}`,
  params
})

export const editEnrolSession = async (params) => await request({
  method: 'put',
  url: `/coaching/editEnrolSession/${params.id}/${params.orgId}`,
  params
})

export const cancelEnrolment = async (params) => await request({
  method: 'put',
  url: `/coaching/cancelEnrolment/${params.id}/${params.orgId}`,
  params
})

export const refundedEnrolment = async (params) => await request({
  method: 'put',
  url: `/coaching/refundedEnrolment/${params.id}`,
  params
})

export const pauseEnrolment = async params => await request({
  method: 'put',
  url: `/coaching/pauseEnrolment/${params.id}/${params.orgId}`
})

export const unpauseEnrolment = async params => await request({
  method: 'put',
  url: `/coaching/unpauseEnrolment/${params.id}/${params.orgId}`,
  params: params.validTill ? { validTill: params.validTill } : {}
})

export const getEnrolmentForBatch = async (batchId) => await request({
  method: 'get',
  url: `/coaching/enrolment/${batchId}`
})

export const getPrograms = async (orgId) => await request({
  method: 'get',
  url: `/coaching/programs/${orgId}`
})

export const addProgram = async (data) => await request({
  method: 'post',
  url: '/coaching/addProgram',
  data
})

export const editProgram = async (data) => await request({
  method: 'put',
  url: '/coaching/editProgram',
  data
})

export const editPubProgram = async (data) => await request({
  method: 'put',
  url: '/coaching/editPubProgram',
  data
})

export const delProgram = async (data) => await request({
  method: 'delete',
  url: `/coaching/delProgram/${data.id}/${data.orgId}`
})

export const publishProgram = async (data) => await request({
  method: 'put',
  url: `/coaching/publishProgram/${data.id}/${data.orgId}`
})

export const pauseProgram = async (data) => await request({
  method: 'put',
  url: `/coaching/pauseProgram/${data.id}/${data.orgId}/${data.pause}`
})

export const endProgram = async (data) => await request({
  method: 'put',
  url: `/coaching/endProgram/${data.id}/${data.orgId}`
})

export const publishProgramMetrics = async (data) => await request({
  method: 'put',
  url: `/metrics/publish/${data.progId}/${data.orgId}`,
  data
})

export const getProgressHistory = async (progId, orgId) => await request({
  method: 'get',
  url: `/metrics/progressHistory/${progId}/${orgId}`
})

export const editProgramDates = async (params) => await request({
  method: 'put',
  url: `/coaching/editProgramDates/${params.id}/${params.orgId}`,
  params
})

export const addBatch = async (data) => await request({
  method: 'post',
  url: `/coaching/addBatch/${data.programId}/${data.orgId}`,
  data
})

export const editBatch = async (data) => await request({
  method: 'put',
  url: `/coaching/editBatch/${data.programId}/${data.orgId}`,
  data
})

export const archiveBatch = async (data) => await request({
  method: 'post',
  url: `/coaching/archiveBatch/${data.id}/${data.orgId}`
})

export const getCoaches = async (id) => await request({
  method: 'get',
  url: `/coaching/coach/${id}`
})

export const getBatchTimings = async (data) => await request({
  method: 'get',
  url: `/coaching/batchTimings/${data.batchId}/${data.orgId}`
})

export const addBatchTiming = async (data) => await request({
  method: 'post',
  url: `/coaching/addBatchTiming/${data.batchId}/${data.orgId}`,
  data
})

export const editBatchTiming = async (data) => await request({
  method: 'put',
  url: `/coaching/editBatchTiming/${data.batchId}/${data.orgId}`,
  data
})

export const delBatchTiming = async (data) => await request({
  method: 'delete',
  url: `/coaching/delBatchTiming/${data.id}/${data.timingId}/${data.orgId}`
})

export const getTraineeDetails = async (data) => await request({
  method: 'get',
  url: `/coaching/traineeDetails/${data.id}/${data.orgId}`
})

export const getCustAttrs = async (orgId) => await request({
  method: 'get',
  url: `/coaching/custAttrs/${orgId}`
})

export const addCustAttr = async (data) => await request({
  method: 'post',
  url: `/coaching/addCustAttr/${data.orgId}`,
  data
})

export const editCustAttr = async (data) => await request({
  method: 'put',
  url: `/coaching/editCustAttr/${data.orgId}`,
  data
})

export const delCustAttr = async (data) => await request({
  method: 'delete',
  url: `/coaching/delCustAttr/${data.id}/${data.orgId}`
})

export const editMemberCAs = async (data) => await request({
  method: 'put',
  url: `/coaching/editMemberCAs/${data.orgId}/${data.memId}`,
  data: data.custAttrs
})

export const editEnrolCAs = async (data) => await request({
  method: 'put',
  url: `/coaching/editEnrolCAs/${data.orgId}/${data.enrolId}`,
  data: data.custAttrs
})

export const saveEnrolRemarks = async (data) => await request({
  method: 'put',
  url: `/coaching/remarks/${data.orgId}/${data.enrolId}`,
  data: { remarks: data.remarks, visible: data.visible, date: data.date }
})

export const getBillPlans = async (orgId) => await request({
  method: 'get',
  url: `/mgmt/billPlans/${orgId}`
})

export const addBillPlan = async (data) => await request({
  method: 'post',
  url: '/mgmt/addBillPlan',
  data
})

export const editBillPlan = async (data) => await request({
  method: 'put',
  url: '/mgmt/editBillPlan',
  data
})

export const delBillPlan = async (data) => await request({
  method: 'delete',
  url: `/mgmt/delBillPlan/${data.id}`
})

export const editOrgPlan = async (data) => await request({
  method: 'put',
  url: `/mgmt/editOrgPlan/${data.orgId}`,
  data: data.plan
})

export const renewSubs = async (data) => await request({
  method: 'post',
  url: `mgmt/renewSubs/${data.orgId}`,
  data
})

export const upgradeSubs = async (data) => await request({
  method: 'post',
  url: `mgmt/upgradeSubs/${data.orgId}`,
  data
})

export const completeRUSubs = async (data, upgrade) => await request({
  method: 'put',
  url: `mgmt/${upgrade ? 'completeUpgradeSubs' : 'completeRenewSubs'}/${data.orgId}`,
  data
})

export const getOrgPayments = async (data) => await request({
  method: 'get',
  url: `/org/orgPayments/${data.orgId}`
})

export const getOrgStats = async (data) => await request({
  method: 'get',
  url: `/org/orgStats/${data.orgId}`
})

export const getCategories = async () => await request({
  method: 'get',
  url: '/mgmt/categories'
})

export const getCategoryValues = async (catId) => await request({
  method: 'get',
  url: `/mgmt/catValues/${catId}`
})

export const addCategory = async (data) => await request({
  method: 'post',
  url: '/mgmt/addCategory',
  data
})

export const editCategoryValue = async (data) => await request({
  method: 'put',
  url: `/mgmt/editCategory/${data.id}`,
  data
})

export const delCategoryValue = async (catId) => await request({
  method: 'delete',
  url: `/mgmt/delCategory/${catId}`
})

export const getMySubscriptions = async () => await request({
  method: 'get',
  url: 'person/subscriptions'
})

export const getChildSubscriptions = async (data) => await request({
  method: 'get',
  url: `member/childSubs/${data?.id}`
})

export const getSubscriptions = async (id) => await request({
  method: 'get',
  url: `/member/subscriptions/${id}`
})

export const getSubscriptionSlotsForField = async (fieldId) => await request({
  method: 'get',
  url: `/member/fldSlots/${fieldId}`
})

export const addSubscription = async (orgId, data) => await request({
  method: 'post',
  url: `/member/addSubscription/${orgId}`,
  data
})

export const editSubscription = async (data) => await request({
  method: 'put',
  url: `/member/editSubscription/${data.orgId}/${data.id}`,
  data
})

export const completeSubscription = async (data, renew) => await request({
  method: 'put',
  url: renew ? '/member/renewSubscription/' : '/member/completeSubscription/',
  data
})

export const renewSubscription = async (data) => await request({
  method: 'post',
  url: 'member/renewSubscription/',
  data
})

export const cancelSubscription = async (params) => await request({
  method: 'put',
  url: `/member/cancelSubscription/${params.id}/`,
  params
})

export const refundedSubscription = async (params) => await request({
  method: 'put',
  url: `/member/refundedSubscription/${params.id}`,
  params
})

export const getSubscriberDetails = async (id, orgId) => await request({
  method: 'get',
  url: `/member/subDetails/${id}/${orgId}/`
})

export const getSubscription = async (id) => await request({
  method: 'get',
  url: `member/sub/${id}`
})

export const markSubAttendance = async (orgId, data) => await request({
  method: 'post',
  url: `/member/markSubAttendance/${orgId}`,
  data
})

export const markBulkSubAttendance = async (orgId, data) => await request({
  method: 'post',
  url: `/member/markBulkSubAttendance/${orgId}`,
  data
})

export const getSubscriptionsForCoach = async (data) => await request({
  method: 'get',
  url: `member/subs/coach/${data.orgId}`
})

export const getSubClassesForCoach = async () => await request({
  method: 'get',
  url: 'member/subclasses/coach'
})

export const getPendSettles = async (orgId) => await request({
  method: 'get',
  url: `/mgmt/pendSettles/${orgId}`
})

export const getSettles = async (orgId) => await request({
  method: 'get',
  url: `/mgmt/settles/${orgId}`
})

export const makeSettle = async (data) => await request({
  method: 'post',
  url: '/mgmt/makeSettle',
  data
})

export const editSettle = async (data) => await request({
  method: 'put',
  url: '/mgmt/editSettle',
  data
})

export const delSettle = async (data) => await request({
  method: 'delete',
  url: `/mgmt/delSettle/${data.id}`
})

export const getDiscCodes = async (params) => await request({
  method: 'get',
  url: `/disc/codes/${params.id}/${params.pId}`,
  params
})

export const validateDiscCode = async (params) => await request({
  method: 'post',
  url: `/disc/validate/${params.id}`,
  params
})

export const getDiscounts = async (orgId) => await request({
  method: 'get',
  url: `/disc/${orgId}`
})

export const addDiscount = async (data) => await request({
  method: 'post',
  url: `/disc/addDiscount/${data.orgId}`,
  data
})

export const editDiscount = async (data) => await request({
  method: 'put',
  url: `/disc/editDiscount/${data.orgId}`,
  data
})

export const delDiscount = async (data) => await request({
  method: 'delete',
  url: `/disc/delDiscount/${data.orgId}/${data.id}`
})

export const getDiscUsage = async (orgId, id) => await request({
  method: 'get',
  url: `/disc/usage/${orgId}/${id}`
})

// Metrics
export const getMetrics = async (orgId) => await request({
  method: 'get',
  url: `/metrics/all/${orgId}`
})

export const addMetric = async (orgId, data) => await request({
  method: 'post',
  url: `/metrics/add/${orgId}`,
  data
})

export const editMetric = async (orgId, data) => await request({
  method: 'put',
  url: `/metrics/edit/${orgId}`,
  data
})

export const delMetric = async (id, orgId) => await request({
  method: 'delete',
  url: `/metrics/del/${id}/${orgId}`
})

export const suggestMetric = async (orgId, data) => await request({
  method: 'post',
  url: `/metrics/suggest/${orgId}`,
  data
})

export const getProfileMetrics = async (id, orgId, { from, to }) => await request({
  method: 'get',
  url: `/metrics/profile/${id}/${orgId}`,
  params: { from, to }
})

export const getProgramBatchMetrics = async (orgId, { from, to, programId, batchId }) => await request({
  method: 'get',
  url: `/metrics/progBatch/${orgId}`,
  params: { from, to, programId, batchId }
})

export const getAllMetrics = async (id, orgId) => await request({
  method: 'get',
  url: `/metrics/allData/${id}/${orgId}`
})